// Drop selected profiles that are no longer on the current page.
export const pruneSelectedProfilesToVisibleUlids = (selectedSet, visibleUlids) => {
  const visible = new Set(visibleUlids || []);

  return new Set([...(selectedSet || [])].filter((ulid) => visible.has(ulid)));
};

// Snapshot of search + filters. Used so changing pages does not clear selection.
export const buildCompareSelectionFilterFingerprint = ({ searchTerm, selectedFilters }) => (
  JSON.stringify({
    searchTerm: searchTerm || '',
    selectedFilters: selectedFilters || {},
  })
);
